import { Spinner } from '@apex/component-library'
import { Box, Stack, Text, VStack } from '@chakra-ui/react'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { isEmpty, startsWith } from 'lodash'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { AccountSearchBar, AccountsTable } from '.'
import { LayoutContext } from '../../containers/contexts/layout/LayoutContext'
import { useAccountSearch } from '../../hooks'
import { MessageCenter } from '../MessageCenter'
import styles from '../TransferSearch/styles.module.less'

const AccountSearchPage = ({
  history,
  location: { search },
}: RouteComponentProps) => {
  const {
    accountSearchState: {
      loadingResults,
      errorMessage,
      accountResults,
      searchTerm,
    },
    searchAccounts,
  } = useAccountSearch()
  const { headerHeight, footerHeight } = useContext(LayoutContext)
  const [tableDimensions, setTableDimensions] = useState({
    height: 0,
    width: 0,
  })
  const accountSearchBarRef = useRef<HTMLDivElement>(null)
  useState(() => {
    if (startsWith(search, '?q=')) {
      const querySearch = decodeURIComponent(search.substring('?q='.length))
      if (querySearch !== searchTerm) {
        searchAccounts(querySearch, history)
      }
    }
  })

  const searchBarHeight = accountSearchBarRef.current?.clientHeight || 0

  useEffect(() => {
    const recalcTableDimensions = () => {
      setTableDimensions({
        height:
          window.innerHeight - headerHeight - footerHeight - searchBarHeight,
        width: window.innerWidth,
      })
    }
    recalcTableDimensions()
    window.addEventListener('resize', recalcTableDimensions)

    return () => {
      window.removeEventListener('resize', recalcTableDimensions)
    }
  }, [headerHeight, footerHeight, searchBarHeight])

  return (
    <VStack spacing={0} flex="1 1 auto" align="stretch">
      <Box ref={accountSearchBarRef}>
        <AccountSearchBar />
      </Box>
      {loadingResults && (
        <VStack justifyContent="center" flex="1 1 auto">
          <Spinner size="lg" />
        </VStack>
      )}
      {!loadingResults && errorMessage && (
        <Box className={styles.messageBanner}>
          <MessageCenter errorMessages={[errorMessage]} />
        </Box>
      )}
      {!loadingResults &&
        !errorMessage &&
        isEmpty(accountResults) &&
        isEmpty(searchTerm) && (
          <Stack direction="column" flex="1 1 auto" alignItems="flex-start">
            <Text as="h1" textStyle="h1" pt={12} pl={3}>
              Initiate Account Transfer
            </Text>
            <Text pt={4} pl={3}>
              To get started, locate the receiving account. You can search by
              account number, name, or SSN above.
            </Text>
          </Stack>
        )}
      {!loadingResults && !errorMessage && !isEmpty(searchTerm) && (
        <Stack direction="column" flex="1 1 auto" alignItems="flex-start">
          <AccountsTable
            accountResults={accountResults}
            height={tableDimensions.height}
            width={tableDimensions.width}
          />
        </Stack>
      )}
    </VStack>
  )
}

export default withRouter(AccountSearchPage)
